/* eslint-disable no-alert */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Row, Col, Card, CardBody, CardTitle,
} from 'reactstrap';
// import moment from 'moment';
import { withTranslation } from 'react-i18next';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import { post } from '../../helpers/api_helper';
import { Can } from '../../utilities/Can';
import BaseGrid from '../../components/Common/BaseGrid';
import * as url from '../../helpers/url_helper';
import DeviceFormModal from '../../components/Device/DeviceFormModal';

function Compatibility(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const [modalOpen, setModalOpen] = useState(false);
  const [modalEntity, setModalEntity] = useState({});
  const [signal, setSignal] = useState(0);

  const editEntity = (entity) => {
    setModalEntity(entity);
    setModalOpen(true);
  };

  const createEntity = () => {
    setModalEntity({
      type: '',
      source: '',
      identifier: '',
    });
    setModalOpen(true);
  };

  const deleteEntity = async (entity, e) => {
    const btn = e.currentTarget;

    btn.disabled = true;
    btn.blur();
    btn.firstChild.classList.toggle('bx-spin');

    // eslint-disable-next-line no-restricted-globals
    const cnfrm = confirm(props.t(`Are you sure you want to delete ${entity.id}?`));

    if (cnfrm) {
      try {
        await post(url.DELETE_DEVICES, { id: entity.id });

        toastr.success(props.t(`Deleted entity ID: ${entity.id}`), props.t('Success'));
        setSignal(signal + 1);
      } catch (error) {
        toastr.error(error.message, props.t('Error'));
      } finally {
        btn.disabled = false;
        btn.firstChild.classList.toggle('bx-spin');
      }
    }
  };

  const onModalSuccess = () => {
    setSignal(signal + 1);
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <CardTitle className="h4">{props.t('Devices')}</CardTitle>

                <Can i="see" this="Devices">
                  <BaseGrid
                    url={url.GET_DEVICES}
                    shouldUpdate={signal}
                    hasSearch
                    create={createEntity}
                    className="table table-sm table-hover table-bordered fs-6"
                    config={
                    {
                      columns: {
                        id: { label: props.t('ID'), sort: true },
                        brand: { label: props.t('Brand'), sort: true },
                        model: { label: props.t('Model'), sort: true },
                        product_type: { label: props.t('Type'), sort: true },
                        product_sub_type: { label: props.t('Sub Type'), sort: true },
                        size: { label: props.t('Size'), sort: true },
                        marketing_title: { label: props.t('Title'), sort: true },
                        production_year: { label: props.t('Year'), sort: true },
                        color_finish: { label: props.t('Color/Finish'), sort: true },
                        actions: {
                          label: props.t('Actions'),
                          actions: [
                            {
                              key: 'edit',
                              icon: 'bx bx-pencil',
                              class: 'btn btn-sm btn-soft-dark',
                              alt: props.t('Edit'),
                              click: editEntity,
                            },
                            {
                              key: 'delete',
                              icon: 'mdi mdi-delete',
                              class: 'btn btn-sm btn-soft-danger',
                              alt: props.t('Delete'),
                              click: deleteEntity,
                            },
                          ],
                        },
                      },
                      pagination: {
                        sort: 'id',
                        direction: 'asc',
                        perPage: 30,
                      },
                    }
                    }
                  />
                </Can>

                <Can not i="see" this="Users"><p>{props.t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

      <DeviceFormModal
        shown={modalOpen}
        entity={modalEntity}
        onSuccess={onModalSuccess}
      />
    </div>
  );
}

Compatibility.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(Compatibility));
